import { Routes, Route, Navigate } from 'react-router-dom';
import TopNavbar from './components/top-navbar/TopNavbar';
import ErrorBoundary from './ErrorBoundary';
import FirmContainer from './FirmContainer';
import WorkpaperContainer from './WorkpaperContainer';
import ClientQueriesPage from './pages/ClientQueriesPage';
import DashboardPage from './pages/DashboardPage';
import EditGroupPage from './pages/EditGroupPage';
import EntitiesPage from './pages/EntitiesPage';
import EntityOverviewPage from './pages/EntityOverviewPage';
import FilesPage from './pages/FilesPage';
import GroupOverviewPage from './pages/GroupOverviewPage';
import GroupsPage from './pages/GroupsPage';
import InternalCommentsPage from './pages/InternalCommentsPage';
import WorkpaperSettingsPage from './pages/WorkpaperSettingsPage';
import WorkpapersPage from './pages/WorkpapersPage';
import NewEntityPage from './pages/NewEntityPage';
import NewGroupPage from './pages/NewGroupPage';
import NewWorkpaperPage from './pages/NewWorkpaperPage';
import NewOtherSchedulePage from './pages/NewOtherSchedulePage';
import NewUserPage from './pages/NewUserPage';
import OtherSchedulesPage from './pages/OtherSchedulesPage';
import ProceduresPage from './pages/ProceduresPage';
import TrialBalancePage from './pages/TrialBalancePage';
import UserOverviewPage from './pages/UserOverviewPage';
import FirmSettingsPage from './pages/FirmSettingsPage';
import ProcedureTemplatesPage from './pages/ProcedureTemplatesPage';
import NewProcedureTemplatePage from './pages/NewProcedureTemplatePage';
import ProcedureTemplateOverviewPage from './pages/ProcedureTemplateOverviewPage';
import NewTemplateProcedurePage from './pages/NewTemplateProcedurePage';
import EditTemplateProcedurePage from './pages/EditTemplateProcedurePage';
import ChecklistsPage from './pages/ChecklistsPage';
import NewChecklistPage from './pages/NewChecklistPage';
import ChecklistOverviewPage from './pages/ChecklistOverviewPage';
import NewChecklistItemPage from './pages/NewChecklistItemPage';
import EditChecklistItemPage from './pages/EditChecklistItemPage';
import UpdateTrialBalancePage from './pages/UpdateTrialBalancePage';
import JournalsPage from './pages/JournalsPage';
import JournalPage from './pages/JournalPage';
import NewJournalPage from './pages/NewJournalPage';
import EditJournalPage from './pages/EditJournalPage';
import SubscriptionBanner from './components/subscription-banner/SubscriptionBanner';
import FirmDashboardPage from './pages/FirmDashboardPage';
import WorksheetPageV2 from './pages/WorksheetPageV2';
import CustomWorksheetTemplatesPage from './pages/CustomWorksheetTemplatesPage';
import CimplicoStaffRoute from './components/cimplico-staff-route/CimplicoStaffRoute';
import NewCalculationTemplatePage from './pages/NewCalculationTemplatePage';
import CustomWorksheetTemplatePage from './pages/CustomWorksheetTemplatePage';
import CalculationPage from './pages/CalculationPage';
import CalculationsPage from './pages/CalculationsPage';
import NewCalculationPage from './pages/NewCalculationPage';

function App(): JSX.Element {
    return (
        <div>
            <TopNavbar />
            <ErrorBoundary>
                <SubscriptionBanner />
                <Routes>
                    {/* FIRM LEVEL ROUTES */}
                    <Route path="*" element={<FirmContainer />}>
                        <Route path="dashboard" element={<FirmDashboardPage />} />
                        <Route path="groups">
                            <Route index element={<GroupsPage />} />
                            <Route path="new" element={<NewGroupPage />} />
                            <Route path=":id">
                                <Route index element={<GroupOverviewPage />} />
                                <Route path="edit" element={<EditGroupPage />} />
                            </Route>
                        </Route>
                        <Route path="entities">
                            <Route index element={<EntitiesPage />} />
                            <Route path="new" element={<NewEntityPage />} />
                            <Route path=":id" element={<EntityOverviewPage />} />
                        </Route>
                        <Route path="workpapers">
                            <Route index element={<WorkpapersPage />} />
                            <Route path="new" element={<NewWorkpaperPage />} />
                        </Route>
                        <Route path="templates">
                            <Route index element={<Navigate to={'../dashboard'} />} />
                            <Route path="procedures">
                                <Route index element={<ProcedureTemplatesPage />} />
                                <Route path="new" element={<NewProcedureTemplatePage />} />
                                <Route path=":id">
                                    <Route index element={<ProcedureTemplateOverviewPage />} />
                                    <Route path="edit/:procedureId" element={<EditTemplateProcedurePage />} />
                                    <Route path="new-procedure" element={<NewTemplateProcedurePage />} />
                                </Route>
                            </Route>
                            <Route path="checklists">
                                <Route index element={<ChecklistsPage />} />
                                <Route path="new" element={<NewChecklistPage />} />
                                <Route path=":id">
                                    <Route index element={<ChecklistOverviewPage />} />
                                    <Route path="edit/:itemId" element={<EditChecklistItemPage />} />
                                    <Route path="new-item" element={<NewChecklistItemPage />} />
                                </Route>
                            </Route>
                            <Route path="calculations" element={<CimplicoStaffRoute />}>
                                <Route index element={<CustomWorksheetTemplatesPage />} />
                                <Route path="new" element={<NewCalculationTemplatePage />} />
                                <Route path=":id">
                                    <Route index element={<CustomWorksheetTemplatePage />} />
                                </Route>
                            </Route>
                        </Route>
                        <Route path="users">
                            <Route path="new" element={<NewUserPage />} />
                            <Route path=":id" element={<UserOverviewPage />} />
                        </Route>
                        <Route path="settings" element={<FirmSettingsPage />} />
                        <Route path="*" element={<Navigate to="dashboard" />} />
                    </Route>
                    {/* WORKPAPER LEVEL ROUTES */}
                    <Route path="workpapers/:workpaperId/*" element={<WorkpaperContainer />}>
                        {/* DASHBOARD */}
                        <Route path="dashboard" element={<DashboardPage />} />
                        {/* PROCEDURES */}
                        <Route path="procedures">
                            <Route index element={<ProceduresPage />} />
                        </Route>
                        {/* TRIAL BALANCE */}
                        <Route path="trial-balance">
                            <Route index element={<TrialBalancePage />} />
                            <Route path="update" element={<UpdateTrialBalancePage />} />
                            {/* <Route path=":id" element={<WorksheetPage />} /> */}
                            <Route path=":id/*" element={<WorksheetPageV2 />} />
                        </Route>
                        {/* OTHER SCHEDULES */}
                        <Route path="other-schedules">
                            <Route index element={<OtherSchedulesPage />} />
                            <Route path="new" element={<NewOtherSchedulePage />} />
                            <Route path=":id/*" element={<WorksheetPageV2 />} />{' '}
                        </Route>
                        {/* JOURNALS */}
                        <Route path="journals">
                            <Route index element={<JournalsPage />} />
                            <Route path=":id" element={<JournalPage />} />
                            <Route path="new" element={<NewJournalPage />} />
                            <Route path=":id/edit" element={<EditJournalPage />} />
                        </Route>
                        {/* CALCULATIONS */}
                        <Route path="calculations">
                            <Route index element={<CalculationsPage />} />
                            <Route path=":id" element={<CalculationPage />} />
                            <Route path="new" element={<NewCalculationPage />} />
                        </Route>

                        {/* FILES */}
                        <Route path="files" element={<FilesPage />} />
                        {/* INTERNAL-COMMENTS */}
                        <Route path="internal-comments" element={<InternalCommentsPage />} />
                        {/* CLIENT QUERIES */}
                        <Route path="client-queries" element={<ClientQueriesPage />} />
                        {/* SETTINGS */}
                        <Route path="settings" element={<WorkpaperSettingsPage />} />

                        <Route path="*" element={<Navigate to="dashboard" />} />
                    </Route>
                </Routes>
            </ErrorBoundary>
        </div>
    );
}
export default App;
